/**
 * API client de Reports.
 */

import { api } from "./client";
import type {
  Report,
  ReportFormat,
  ReportGenerateRequest,
  ReportListFilters,
  ReportListItem,
} from "@/types";

export const reportsApi = {
  async list(filters?: ReportListFilters): Promise<ReportListItem[]> {
    const { data } = await api.get<ReportListItem[]>("/reports", { params: filters });
    return data;
  },

  async get(id: string): Promise<Report> {
    const { data } = await api.get<Report>(`/reports/${id}`);
    return data;
  },

  async generate(payload: ReportGenerateRequest): Promise<Report> {
    const { data } = await api.post<Report>("/reports/generate", payload);
    return data;
  },

  async rename(id: string, name: string): Promise<Report> {
    const { data } = await api.patch<Report>(`/reports/${id}`, { name });
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`/reports/${id}`);
  },

  /** URL pra download (com Authorization header passado pelo axios). */
  downloadUrl(id: string, fmt: ReportFormat): string {
    return `${api.defaults.baseURL ?? ""}/reports/${id}/download/${fmt}`;
  },

  /** Download via axios (carrega Bearer token, força attachment). */
  async download(id: string, fmt: ReportFormat): Promise<Blob> {
    const { data } = await api.get<Blob>(`/reports/${id}/download/${fmt}`, {
      responseType: "blob",
    });
    return data;
  },
};
